export class MemberCompanyModel {
    public id :string;
    public ImagePath: string;
    public companyName:string;
    public city:string;
    public countryCode:string;
    public websiteUrl:string;
    public active:boolean;
    public address:string;
    public phone:string;
    public taxNumber:string;
    public email:string;
    public generalManagerName:string;
    public generalManagerProfileImageUrl:string;
    public generalManagerRoleName : string;
    public numberOfEvents :number;
    public numberOfVenues :number;
    public membershipProductName:string;
    public membershipRecurringInterval:string;
    public price:string;
    public startMembershipDate:any;
    public TotalPrice:string;
}